<template>
  <div class="wrapper">
    <div class="navBar">
      <div class="navBox el-icon-document">试题({{ totalQuestionNum }})</div>
      <div class="navBox el-icon-edit">
        已用的试题({{ totalUserQuestionNum }})
      </div>
      <div class="navBox el-icon-menu">分类({{ groupNum }})</div>
    </div>
    <div class="contentBox">
      <div v-if="!showImportRecords">
        <div class="titleLable">
          共有{{ otherData.totalRecord }}条导入记录，共有{{
            otherData.totalQuestionNum
          }}题
        </div>

        <div
          class="contentBar"
          v-for="(item, index) in importRecordList"
          :key="'record' + index"
        >
          <div class="recordBox">
            <div class="questionData">
              <div class="titleBar">
                {{ item.fileName }}
              </div>

              <div class="settingBar">
                {{ item.accountName }} |
                <span class="importTime"
                  >导入时间：{{ item.importTime }}分</span
                >
              </div>
            </div>

            <div class="keyvalBox centerFont">
              <div class="questionNum">
                {{ item.questionNum }}
              </div>
              <div>导入试题数量</div>
            </div>

            <el-button
              class="actBar"
              type="primary"
              round
              @click="
                goToDetailAndChangeShowStatus(
                  item.id,
                  item.importTime,
                  item.fileName
                )
              "
              >查看导入记录</el-button
            >
          </div>
        </div>
      </div>
      <div v-else>
        <div class="import-record-label">
          <span class="titleLable">
            {{ fileName }} | 导入时间 : {{ importTime }} 共{{
              recordTotalQuestionNum
            }}道题
          </span>

          <el-button class="back-btn" size="small" @click="reurnImportRecord()"
            >返回</el-button
          >
        </div>

        <div
          class="contentBar"
          v-for="(item, index) in importRecordDetailList"
          :key="'detail' + index"
        >
          <div class="detailBox">
            <div>
              <div class="ques-title">
                <div class="left">
                  <span class="ques-number">
                    {{ index + 1 }}/{{ recordTotalQuestionNum }}
                  </span>
                  <span class="ques-type">{{ item.typeName }} </span>
                  <span class="questionTitle">{{ item.content }} </span>
                </div>
                <div class="right">
                  <span class="ques-score">{{ item.score }}分</span>&emsp;
                  <el-button type="text" @click="isShowOptions(index)">
                    <span>{{ !item.boxshow ? "展开" : "收起" }}</span>
                  </el-button>
                </div>
              </div>

              <div class="question-option-list" v-show="item.boxshow">
                <ol>
                  <li
                    v-for="(item1, index) in importRecordDetailList[index]
                      .answerDTOList"
                    :key="index"
                  >
                    <span
                      class="ques-answer-list"
                      v-html="item1.content"
                    ></span>
                  </li>
                </ol>
                <div class="ques-answer-true">
                  正确答案：{{ item.trueAnswer }}
                </div>
                <div class="ques-answer-analysis">
                  题目解析：<span> {{ item.analysis || "无解析" }}</span>
                </div>
              </div>

              <div class="detailLabel">
                <span class="labels other">标签：</span>
                <span class="labels">{{ item.levelName }}</span>
              </div>
              <div class="detailLabel">
                <span class="labels other"
                  >分类：{{ item.groupName }}&emsp;</span
                >
                <span class="labels other">作者：{{ item.author }} &emsp;</span>
                <span class="labels other">更新于：{{ item.updateDate }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <el-row>
        <el-col :span="24">
          <div class="pagination">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="paginations.page_index"
              :page-sizes="paginations.page_sizes"
              :page-size.sync="paginations.page_size"
              :layout="paginations.layout"
              :total="paginations.total"
            >
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {
  importQuestionList,
  importQuestionDetailList,
} from "@/api/question.js";
export default {
  data() {
    return {
      paginations: {
        page_index: 1, //当前页
        page_size: 30, //每页多少条
        total: 30,
        page_sizes: [10, 15, 30, 50],
        layout: "sizes, prev, pager, next,jumper",
      },
      searchCondition: {
        id: "",
        pageSize: 30,
        jumpPage: 1,
        accountId: 1,
      },
      showImportRecords: false,
      importRecordList: [],
      importRecordDetailList: [],
      otherData: [],
      importTime: "",
      fileName: "",
      totalQuestionNum: "",
      totalUserQuestionNum: "",
      groupNum: "",
      recordTotalQuestionNum: "",
    };
  },

  created() {},
  mounted() {
    this.getRecordList();
  },
  methods: {
    goToDetailAndChangeShowStatus(id, importTime, fileName) {
      this.showImportRecords = true;
      console.log(id, importTime, fileName);
      this.importTime = importTime;
      this.fileName = fileName;
      this.searchCondition.id = id;
      this.getRecordDetailList();
    },

    handleSizeChange(page_size) {
      console.log(`每页 ${page_size} 条`);
      this.paginations.page_size = page_size;
      this.searchCondition.pageSize = page_size;
      this.getRecordList();
    },
    handleCurrentChange(page) {
      console.log(`当前页: ${page}`);
      this.paginations.page_index = page;
      this.searchCondition.jumpPage = page;
      this.getRecordList();
    },

    getRecordList() {
      importQuestionList(this.searchCondition).then((data) => {
        console.log("导入分页结果", data);
        this.importRecordList = data.dtoList;
        this.otherData = data;
        this.totalQuestionNum = data.totalQuestionNum;
        this.totalUserQuestionNum = data.totalUserQuestionNum;
        this.groupNum = data.groupNum;
        this.recordTotalQuestionNum = data.recordTotalQuestionNum;
        this.total = data.getTotalRecord;
      });
    },
    getRecordDetailList() {
      importQuestionDetailList(this.searchCondition).then((data) => {
        console.log("导入详情结果", data);

        // data.dtoList.forEach((item) => {
        //   this.$set(item, "boxshow", false);
        //    this.$set(item, "trueAnswer", "");
        // });
        for (let i = 0; i < data.dtoList.length; i++) {
          //添加一个字段 判断 选项展示与否 默认 false不展示
          data.dtoList[i].boxshow = false;
          var trueAnswer = "";
          //处理题目带<p>标签
          var reg = /<\/?.+?\/?>/g;
          data.dtoList[i].content = data.dtoList[i].content.replace(reg, "");
          data.dtoList[i].analysis = data.dtoList[i].analysis.replace(reg, "");
          console.log(data.dtoList[i].content.replace(reg, ""));
          //  let answerDTOList = [];
          console.log("hhh=", data.dtoList[i]);
          for (let j = 0; j < data.dtoList[i].answerDTOList.length; j++) {
            if (data.dtoList[i].answerDTOList[j].isCorrect === 1) {
              trueAnswer += String.fromCharCode("A".charCodeAt(0) + j);
            }
            data.dtoList[i].trueAnswer = trueAnswer;

            // data.dtoList[i].answerDTOList[j].content=
            //   `${String.fromCharCode("A".charCodeAt(0) + j)}. ${
            //     data.dtoList[i].answerDTOList[j].content
            //   }`
          }

          //  data.dtoList[i].answerDTOList = answerDTOList;
        }

        this.importRecordDetailList = data.dtoList;

        console.log("查询结果加字母后的", this.importRecordDetailList);
      });
    },
    reurnImportRecord() {
      this.showImportRecords = false;
      this.searchCondition.id = null;
      this.importRecordDetailList = [];
      this.getRecordList();
    },

    isShowOptions(index) {
      this.importRecordDetailList[index].boxshow = !this.importRecordDetailList[
        index
      ].boxshow;
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  background: #fff;
  font-size: 12px;
  margin: 15px;
  .navBar {
    display: flex;
    padding: 15px;
    justify-content: space-between;
    .navBox {
      display: flex;
      font-size: 1.5rem;
      border-radius: 10px;
      height: 95px;
      width: 30%;
      color: #fff;
      align-items: center;
      justify-content: center;
      i {
        font-size: 2rem;
      }
    }
    .navBox:nth-child(1) {
      background: #63b5ef;
    }
    .navBox:nth-child(2) {
      background: #92cb7b;
    }
    .navBox:nth-child(3) {
      background: #efd07c;
    }
    .navBox:nth-child(4) {
      background: #ec8472;
    }
  }

  .contentBox {
    border: 1px solid #ccc;
    padding: 20px;

    .contentBar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex: 1;
      margin-bottom: 20px;
      // border-bottom: 1px solid #ccc;
      border: 1px solid #ccc;
      padding: 20px 10px;
      padding-top: 20px;
      border-radius: 4px;
      .el-checkbox {
        margin-right: 10px;
      }
      .tableImg {
        width: 140px;
      }
      .recordBox {
        align-items: center;
        flex: 1;
        display: flex;
        margin: 0 20px;
        width: 100%;
        .questionData {
          flex: 1;
        }
        .keyvalBox {
          // display: flex;
          width: 120px;
          text-align: center;
          margin: 0 5px;
          .questionNum {
            font-size: 1.6rem;
          }
        }
        .actBar {
          // display: block;
          width: 130px;
          background-color: #36aafd;
          color: #ffffff;
          font-size: 14px;
          text-align: center;
          float: right;
          line-height: 20px;
          margin: 0 20px;
        }
        .titleBar {
          font-size: 20px;
          display: flex;
          align-items: center;

          .label {
            font-weight: normal;
            font-size: 13px;
            color: #fff;
            background: red;
            padding: 0px 7px;
            margin: 0 10px;
            border-radius: 9px !important;
            vertical-align: top;
            display: inline-block;
            cursor: pointer;
          }
        }
        .settingBar {
          margin-top: 14px;
          font-size: 14px;
          .impotrTime {
            font-size: 14px;
            color: #999999;
            height: 14px;
          }
        }

        .labels {
          //   display: block;
          float: left;
          height: 27px;
          padding: 3px 16px;
          // margin-right: 10px;
          border: 1px solid #999;
          border-radius: 15px !important;
          color: #999;
          font-size: 14px;
          cursor: pointer;
        }
        .other {
          padding: 0;
          border: none;
          line-height: 30px;
          margin-right: 0;
        }
      }
      .detailBox {
        align-items: center;
        flex: 1;
        display: flex;
        margin: 0 20px;
        width: 100%;
        .questionData {
          flex: 1;
        }
        .ques-title {
          display: flex;
          width: 90%;
          font-size: 17px;

          .left {
            vertical-align: middle;

            .ques-type {
              font-size: 12px;
              border: 1px solid;
              border-radius: 2px;
              padding: 2px;
              vertical-align: middle;
              color: #009aff;
              border-color: #009aff;
            }
            .ques-number {
              font-size: 14px;
              color: #fff;
              border-radius: 2px;
              padding: 1px 1px 1px 7px;
              margin-right: 3px;
              border: solid 1px #36aafd;
              background-color: #36aafd;
            }
            .questionTitle {
              display: inline;
            }
          }
          .right {
            position: absolute;
            right: 80px;
          }
        }
        .labels {
          //   display: block;
          float: left;
          height: 27px;
          padding: 3px 16px;
          // margin-right: 10px;
          border: 1px solid #999;
          border-radius: 15px !important;
          color: #999;
          font-size: 14px;
          cursor: pointer;
        }
        .other {
          padding: 0;
          border: none;
          line-height: 30px;
          margin-right: 0;
        }
      }
    }
  }

  .titleLable {
    font-size: 16px;
    color: #999999;
    margin: 10px;
  }

  .centerFont {
    text-align: center;
  }

  .import-record-label {
    font-size: 16px;
    color: #999999;
    margin: 10px 0 20px 15px;
    .back-btn {
      display: inline-block;
      float: right;
      color: #666666;
      font-size: 14px;
    }
  }
  .detailLabel {
    display: flex;
    height: 40px;
    padding-top: 15px;
  }
  .question-option-list {
    ol {
      padding-top: 15px;
      padding-left: 20px;
      li {
        margin-bottom: 15px;
        font-size: 14px;
        list-style-type: upper-latin;
      }
    }

    .ques-answer-true {
      font-size: 14px;

      color: #009aff;
      margin: 0 0 10px;
      padding-top: 10px;
      span {
        padding: 0 12px 20px 0;
        border-left: none;
        color: #999;
      }
    }
    .ques-answer-analysis {
      display: inline-block;
      font-size: 14px;
      padding-top: 10px;
      margin: 0 0 10px;
      border-left: none;
      color: #999;
    }
  }
}
</style>


